module.exports = __webpack_public_path__ + "img/3tadori.ff2f7093.png";